/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import Mark from './Mark';
import Blockquote from './Blockquote';
import ListItem from './ListItem';
import Heading from './Heading';
import TextAlign from './TextAlign';
import Link from './Link';
import Image from './Image';
import TextColor from './TextColor';
import TextSize from './TextSize';

export const STRONG = new Mark('strong');
export const EM = new Mark('em');
export const CODE = new Mark('code');
export const UNDERLINE = new Mark('u');
export const STRIKE = new Mark('s');
export const BLOCKQUOTE = new Blockquote();
export const UL = new ListItem(true);
export const OL = new ListItem(false);
export const H1 = new Heading(1);
export const H2 = new Heading(2);
export const H3 = new Heading(3);
export const H4 = new Heading(4);
export const H5 = new Heading(5);
export const H6 = new Heading(6);
export const FONT_SIZE_8 = new TextSize('8px');
export const FONT_SIZE_9 = new TextSize('9px');
export const FONT_SIZE_10 = new TextSize('10px');
export const FONT_SIZE_11 = new TextSize('11px');
export const FONT_SIZE_12 = new TextSize('12px');
export const FONT_SIZE_13 = new TextSize('13px');
export const FONT_SIZE_14 = new TextSize('14px');
export const FONT_SIZE_15 = new TextSize('15px');
export const FONT_SIZE_16 = new TextSize('16px');
export const FONT_SIZE_17 = new TextSize('17px');
export const FONT_SIZE_18 = new TextSize('18px');
export const FONT_SIZE_19 = new TextSize('19px');
export const FONT_SIZE_20 = new TextSize('20px');
export const FONT_SIZE_21 = new TextSize('21px');
export const FONT_SIZE_22 = new TextSize('22px');
export const FONT_SIZE_23 = new TextSize('23px');
export const FONT_SIZE_24 = new TextSize('24px');
export const ALIGN_LEFT = new TextAlign('left');
export const ALIGN_CENTER = new TextAlign('center');
export const ALIGN_RIGHT = new TextAlign('right');
export const ALIGN_JUSTIFY = new TextAlign('justify');
export const LINK = new Link();
export const IMAGE = new Image();
export const TEXT_COLOR = new TextColor('text_color', 'color');
export const TEXT_BACKGROUND_COLOR = new TextColor('text_background_color', 'backgroundColor');
